// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__B4T9w","column":"styles_column__-w6FA"};